import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  deleting: false,
  data: [],
  units: {},
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0,
  displacementResults: {
    loading: false,
    data: [],
    units: {},
    paginatedElements: 0
  },
};
const hydraulicsDisplacementReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        units: { ...action.payload.units },
        paginatedElements: action.payload.paginatedElements,
        permissionId: action?.payload?.permissionId ?? null,
        permissions: action?.payload?.permissions ?? state?.permissions ?? {},
        createdDetails: action?.payload?.lastUpdate
          ? {
              createdBy: action?.payload?.createdBy,
              lastUpdate: action?.payload?.lastUpdate,
              lastUpdatedBy: action?.payload?.lastUpdatedBy
            }
          : state?.createdDetails,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_RESET:
      return {
        ...initialState
      };
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_SET_FALSE:
      return {
        ...state,
        loading: false,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_RESULT_LIST_LOADING:
      return {
        ...state,
        displacementResults: {
          ...state.displacementResults,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_RESULT_LIST_SUCCESS:
      return {
        ...state,
        displacementResults: {
          ...state.displacementResults,
          loading: false,
          data: [...action.payload.data],
          units: { ...action.payload.units },
          paginatedElements: action.payload.paginatedElements,
          errorMessage: '',
          ph_version: action.payload?.ph_version
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_RESULT_LIST_ERROR:
      return {
        ...state,
        displacementResults: {
          ...state.displacementResults,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    default:
      return state;
  }
};
export default hydraulicsDisplacementReducer;
